import {
  Component,
  ViewEncapsulation,
  OnInit,
  Inject, OnDestroy
} from '@angular/core';

import {
  FormBuilder,
  Validators,
  FormGroup,
  FormControl
} from '@angular/forms';

import {
  MAT_DIALOG_DATA, MatDialogRef, MatSnackBar
} from '@angular/material';
import * as moment from 'moment';
import {UserContext} from '../services/user-context';
import {ApiService} from '../services/api';
import {HttpParams} from '@angular/common/http';


@Component({
  selector: 'app-appointment-dialog',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'appointment-dialog.template.html',
})

export class AppointmentDialogComponent implements OnInit, OnDestroy {
  public form: FormGroup;
  public formErrors = {
    type: '',
    when: ''
  };
  types = ['telehealth','clinic','office','home'];

  loading = false;
  appointment: any;
  users: any[];
  client:any;
  showConfirmCancel = false;

  constructor(private formBuilder: FormBuilder,
              private snackBar: MatSnackBar,
              private userContext: UserContext,
              private api: ApiService,
              public dialogRef: MatDialogRef<AppointmentDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {

    this.api.get<any[]>('/user', new HttpParams().set('account', this.userContext.account.id).set('provider', 'true'))
      .subscribe(result => {
        this.users = result.filter(u => u.firstName && u.lastName && (this.userContext.isAssociate() ? u.id === this.userContext.user.reference : true));
        if( this.appointment && !this.appointment.user_id) {
          let currentUser = this.users.find( u => u.id.includes(userContext.user.reference));
          if( currentUser ) {
            this.form.controls['user_id'].setValue(currentUser.user_id);
          }
        }
      });


    if( data.dataItem ) {
      this.appointment = Object.assign({}, data.dataItem);
      this.appointment.id = data.id;

      this.api.get<any>(`/client/${this.appointment.client_id}`)
        .subscribe(result => {
          this.client = result;
        }, (error) => {
          console.log('Found error ' + JSON.stringify(error));
        });

    } else if( data.client ) {
      this.client = data.client;
      console.log("Beginning client appointment with: " + JSON.stringify(this.client, null, 4));
      let when = moment().add(1, 'day');
      this.appointment = {
        title: "Telehealth Appointment",
        subject: "Assessment",
        type: "telehealth",
        confirmed: false,
        location_id: this.client.location_id,
        account_id: this.client.account_id,
        name: `${this.client.firstName} ${this.client.lastName}`,
        //user_id: this.userContext.user.reference,
        client_id: this.client.id,
        duration: 30,
        when: when,
        providerName: this.userContext.user.name,
        description: `Telehealth Appointment`,
        start: moment(when).toDate(),
        end: moment(when).add(30, 'minutes').toDate()
      };
      console.log("Creating appointment with: " + JSON.stringify(this.appointment, null,4));
    } else {
      this.appointment = Object.assign({}, {
        invitation: true,
        type: 'telehealth',
        title: this.userContext.accountHasOption('emr') ? "Telehealth Appointment" : "TeleConsultation Appointment",
        entity: this.userContext.account.name,
        account_id: this.userContext.account.id,
        duration: 30,
        providerName: this.userContext.user.name,
        confirmed: false,
      });
    }
  }

  public ngOnInit(): void {
    if( this.appointment.invitation ) {
      this.form = this.formBuilder.group({

        when: new FormControl(this.appointment.when ? moment(this.appointment.when).toDate() : moment().add(7, 'days').toDate(), [
          Validators.required
        ]),

        subject: new FormControl(this.appointment.subject, [
          Validators.required
        ]),

        user_id: new FormControl(this.appointment.user_id, [
          Validators.required
        ]),

        name: new FormControl(this.appointment.name, [
          Validators.required,
          Validators.minLength(3)
        ]),

        email: new FormControl(this.appointment.email, [
          Validators.required,
          Validators.email
        ]),

        notes: new FormControl(this.appointment.notes, [
        ]),
      });
    } else {
      this.form = this.formBuilder.group({
        type: new FormControl(this.appointment.type || 'telehealth', [
          Validators.required,
        ]),

        when: new FormControl(this.appointment.when ? moment(this.appointment.when).toDate() : moment().add(7, 'days').toDate(), [
          Validators.required
        ]),

        subject: new FormControl(this.appointment.subject, [
          Validators.required
        ]),

        user_id: new FormControl(this.appointment.user_id, [
          Validators.required
        ]),

        confirmed: new FormControl(this.appointment.confirmed || false, [])
      });
    }
  }

  public ngOnDestroy(): void {
  }

  public dismissCancel(): void {
    this.showConfirmCancel = false;
  }

  public confirmCancel(): void {
    this.showConfirmCancel = false;
    this.cancelAppointment();
  }

  public confirmCancelAppointment() {
    this.showConfirmCancel = true;
  }

  public cancelAppointment() {
    this.appointment = Object.assign(this.appointment, this.form.value);
    this.appointment.cancel = true;
    this.dialogRef.close(this.appointment);
  }

  public save() {
    this.appointment = Object.assign(this.appointment, this.form.value);
    this.dialogRef.close(this.appointment);
  }

  public cancel() {
    this.dialogRef.close();
  }

}
